import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NavArrowDown } from 'iconoir-react';
import { useGetAgents } from 'features/chat/hooks/use-agents';
import { useConfig } from 'hooks/use-config';
import { cn } from 'lib/utils';

type AgentChatHeaderTitleProps = {
  className?: string;
};

export function AgentChatHeaderTitle({ className }: AgentChatHeaderTitleProps) {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { configurationSettings } = useConfig();
  const projectKey = configurationSettings?.blocksKey || '';
  const agentId = searchParams.get('agentId') || searchParams.get('agent');

  const { data: agentsData } = useGetAgents(
    {
      limit: 100,
      offset: 0,
      project_key: projectKey,
    },
    { enabled: !!agentId && !!projectKey }
  );

  const agentName = useMemo(() => {
    const found = agentsData?.agents?.find((agent) => agent.id === agentId);
    return found?.name || t('UNTITLED_AGENT', { defaultValue: 'Untitled Agent' });
  }, [agentId, agentsData?.agents, t]);

  if (!agentId) return null;

  return (
    <button
      type="button"
      className={cn(
        'flex min-w-0 max-w-full items-center gap-2 rounded-2xl text-left',
        className
      )}
    >
      <span className="truncate text-sm font-medium leading-[1.6] text-[#27272C] dark:text-[#F6F6F6]">
        {agentName}
      </span>
      <NavArrowDown
        width={16}
        height={16}
        strokeWidth={1.75}
        className="shrink-0 text-[#27272C] dark:text-[#F6F6F6]"
        aria-hidden
      />
    </button>
  );
}
